<template><svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
    <path d="M8 8.5V1M8 1H1M8 1L1 8" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
    </svg></template>